import { render, staticRenderFns } from "./ProtocolSidebar.vue?vue&type=template&id=00c36950"
import script from "./ProtocolSidebar.vue?vue&type=script&lang=js"
export * from "./ProtocolSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports